import AdapterMoment from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import {responsiveFontSizes} from '@mui/material';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import React, {useContext, useEffect} from 'react';
import {NavStyle, ThemeMode, ThemeStyle} from 'shared/configs/AppEnums';
import AppLocale from 'shared/localization';
import {useUrlSearchParams} from 'use-url-search-params';
import AppContextPropsType from '../../../shared/models/AppContextPropsType';
import AppContext from '../AppContext';
import {useBreakPointDown} from '../Utils';

const CremaThemeProvider: React.FC<React.ReactNode> = (props) => {
  const {
    theme,
    locale,
    isRTL,
    updateThemeMode,
    changeNavStyle,
    updateThemeStyle,
    setRTL,
    updateTheme,
  } = useContext<AppContextPropsType>(AppContext);
  const {muiLocale} = AppLocale[locale.locale];
  const isBelowMd = useBreakPointDown('md');

  const initailValue: InitialType = {};
  const types: TypesType = {};
  const [params] = useUrlSearchParams(initailValue, types);

  useEffect(() => {
    const updateQuerySetting = () => {
      if (params.theme_mode) {
        updateThemeMode!(params.theme_mode as ThemeMode);
      }
    };
    updateQuerySetting();
  }, [params.theme_mode, updateThemeMode]);

  useEffect(() => {
    const updateQuerySetting = () => {
      if (params.is_rtl) {
        setRTL!(params.is_rtl as boolean);
      }
      if (params.is_rtl || isRTL) {
        document.body.setAttribute('dir', 'rtl');
      } else {
        document.body.setAttribute('dir', 'ltr');
      }
    };
    updateQuerySetting();
  }, [isRTL, params.is_rtl, setRTL]);

  useEffect(() => {
    const updateQuerySetting = () => {
      if (params.nav_style) {
        changeNavStyle!(params.nav_style as NavStyle);
      }
    };
    updateQuerySetting();
  }, [changeNavStyle, params.nav_style]);

  useEffect(() => {
    const updateQuerySetting = () => {
      if (params.theme_style) {
        if (params.theme_style === ThemeStyle.MODERN) {
          if (isBelowMd) {
            // @ts-ignore
            theme.overrides.MuiCard.root.borderRadius = 20;
            // @ts-ignore
            theme.overrides.MuiToggleButton.root.borderRadius = 20;
          } else {
            // @ts-ignore
            theme.overrides.MuiCard.root.borderRadius = 30;
            // @ts-ignore
            theme.overrides.MuiToggleButton.root.borderRadius = 30;
          }
          // @ts-ignore
          theme.overrides.MuiButton.root.borderRadius = 30;
          // @ts-ignore
          theme.overrides.MuiCardLg.root.borderRadius = 50;
        } else {
          // @ts-ignore
          theme.overrides.MuiCard.root.borderRadius = 4;
          // @ts-ignore
          theme.overrides.MuiToggleButton.root.borderRadius = 4;
          // @ts-ignore
          theme.overrides.MuiButton.root.borderRadius = 4;
          // @ts-ignore
          theme.overrides.MuiCardLg.root.borderRadius = 4;
        }
        updateTheme!(theme);
        if (
          params.theme_style === ThemeStyle.MODERN ||
          params.theme_style === ThemeStyle.STANDARD
        ) {
          updateThemeStyle!(params.theme_style as ThemeStyle);
        }
      }
    };
    updateQuerySetting();
  }, [params.theme_style, theme, isBelowMd, updateTheme, updateThemeStyle]);

  return (
    <ThemeProvider theme={responsiveFontSizes(createTheme(theme, muiLocale))}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {props.children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default React.memo(CremaThemeProvider);
